import { getGuideIdFromRoutePath } from '../../common/utils/parseGuideParams';
import parseQuery from '../../common/utils/queryString/parse';

export default function gotie(fn, ...params) {
  if (window.gotie) {
    // eslint-disable-next-line
    window.gotie[fn](...params);
  }
}

export function gotieTrack(location) {
  const guideId = getGuideIdFromRoutePath(location.pathname);
  const query = parseQuery(location.search);
  const { source, campaign, adgroup, ad } = query;
  gotie('track', 'pageview', { guideId, source, campaign, adgroup, ad }, true);
}

export function gotieTrackClick(guideId) {
  gotie('track', 'click', { guideId }, true);
}
